/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'ssl-certificate-export-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitle = `${prefix}.modalTitle`;
export const configurationHeader = `${prefix}.configurationHeader`;
export const sslKeyInputLabel = `${prefix}.sslKeyInputLabel`;
export const sslCertificateInputLabel = `${prefix}.sslCertificateInputLabel`;
export const submitBtnLabel = `${prefix}.submitBtnLabel`;

export const ENGLISH = {
    [modalTitle]: 'Export Certificate',
    [configurationHeader]: 'Configuration',
    [sslKeyInputLabel]: 'Key',
    [sslCertificateInputLabel]: 'Certificate',
    [submitBtnLabel]: 'Done',
};
